import styled from '@emotion/styled';
import { ButtonV3 } from '@zola/zola-ui/src/components/ButtonV3';
import { SuiteTile } from 'components/common/ui/SuiteTile';
import { SuiteImage } from 'components/common/ui/SuiteTile/SuiteTile.style';

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 50%);
  grid-template-rows: auto;
  margin-top: -1px;

  border-bottom: 1px solid ${props => props.theme.COLORSV3.BLACK_030};

  ${props => props.theme.MEDIA_QUERY.DESKTOP} {
    grid-template-columns: repeat(4, 25%);
  }
`;

export const Item = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  border-top: 1px solid ${props => props.theme.COLORSV3.BLACK_030};
  border-left: 1px solid ${props => props.theme.COLORSV3.BLACK_030};
  padding: 14px;

  :nth-of-type(2n + 1) {
    border-left: none;
  }

  ${props => props.theme.MEDIA_QUERY.DESKTOP} {
    padding: 20px;

    :nth-of-type(2n + 1) {
      border-left: 1px solid ${props => props.theme.COLORSV3.BLACK_030};
    }

    :nth-of-type(4n + 1) {
      border-left: none;
    }
  }

  ${props => props.theme.MEDIA_QUERY.DESKTOP_XL} {
    padding: 24px;
  }
`;

export const StyledButton = styled(ButtonV3)`
  margin-top: 28px;
  ${props => props.theme.MEDIA_QUERY.MOBILE_XS} {
    height: 38px;
    font-size: ${props => props.theme.FONTS.FONT_SIZE_SMALLER};
  }
`;

export const SuiteTypeTile = styled.div`
  text-align: center;

  ${props => props.theme.MEDIA_QUERY.DESKTOP} {
    padding: 0px 12px;
  }

  ${props => props.theme.MEDIA_QUERY.DESKTOP_LG} {
    padding: 0px 6px;
  }
`;

export const StyledSuiteTile = styled(SuiteTile)`
  ${SuiteImage} {
    padding: 10px;

    ${props => props.theme.MEDIA_QUERY.EXCLUDE_MOBILE_XS} {
      padding: 38px;
    }

    ${props => props.theme.MEDIA_QUERY.DESKTOP} {
      padding: 32px;
    }

    ${props => props.theme.MEDIA_QUERY.DESKTOP_XL} {
      padding: 40px;
    }
  }
`;
